module.exports = __webpack_public_path__ + "a19fe483b4c81d5e64087228a13ba90a.png";